import apiClient from "../../clients/apiClient";
import API_ENDPOINTS from "../../config/apiEndpointsConfig";

export const createClinicalHistoryEndpoint = async data => {
  const endpoint = API_ENDPOINTS.CREATE_CLINICAL_HISTORY();
  try {
    const response = await apiClient.post(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error creating clinical history: ${error.message}`);
  }
};

export const updateClinicalHistoryEndpoint = async (
  data,
  clinicalHistoryId
) => {
  if (!clinicalHistoryId) {
    throw new Error("clinicalHistoryId is required");
  }

  const endpoint = API_ENDPOINTS.UPDATE_CLINICAL_HISTORY(clinicalHistoryId);
  try {
    const response = await apiClient.patch(endpoint, data);
    return response;
  } catch (error) {
    throw new Error(`Error updating clinical history: ${error.message}`);
  }
};

export const deleteClinicalHistoryEndpoint = async clinicalHistoryId => {
  if (!clinicalHistoryId) {
    throw new Error("clinicalHistoryId is required");
  }

  const endpoint = API_ENDPOINTS.DELETE_CLINICAL_HISTORY(clinicalHistoryId);
  try {
    const response = await apiClient.delete(endpoint);
    return response;
  } catch (error) {
    const errorMessage =
      error?.response?.data?.detail ||
      error?.response?.data?.error ||
      error.message;
    throw new Error(`${errorMessage}`);
  }
};
